document.addEventListener('DOMContentLoaded', function() {
    const boatArea = document.querySelector('.Boat_Area');
    const boat = document.querySelector('.Boat_Area .Boat');

    if(boatArea === null || boat === null) {
        return;
    }

    let tick = 0;

    let fps = 60;
    let now;
    let then = Date.now();
    let interval = 1000 / fps;
    let delta;

    function animationLoop() {
        now = Date.now();
        delta = now - then;

        if (delta > interval) {
            then = now - (delta % interval);
            tick++;

            // Get sin function value from -1 to 1 based on tick
            let sin = (Math.sin(tick / 60) * 8) + 2;

            // Get cos function value from -1 to 1 based on tick
            let cos = Math.cos(tick / 60) * 0.3;

            // Set boat angle and position
            boat.style.transform = `translateX(${-cos}rem) rotate(${sin}deg)`;
        }
        // set to 30 fps no matter screen refresh rate
        requestAnimationFrame(animationLoop);
    }

    requestAnimationFrame(animationLoop);
});